import { render, staticRenderFns } from "./modalAttachExternalProvider.vue?vue&type=template&id=a1634f9c&"
import script from "./modalAttachExternalProvider.vue?vue&type=script&lang=js&"
export * from "./modalAttachExternalProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports